import React from 'react';
import clsx from 'clsx';
import FormControl from '@mui/material/FormControl';
import MuiRadioGroup from '@mui/material/RadioGroup';
import Radio from 'pages/Dashboard/components/Input/Radio';
import {
  FieldComponentProps,
} from 'views/EMR/components/FillableForm/types';
import {
  getStableKey,
} from 'views/EMR/components/FillableForm/utils/fieldPositioning';

export default function RadioGroupField({
  field,
  value,
  onChange,
  error = false,
}: FieldComponentProps) {
  return (
    <div className="w-full min-w-0">
      <FormControl className="w-full">
        <MuiRadioGroup
          id={field?.id ?? ''}
          key={field.id}
          name={field?.name ?? ''}
          value={value?.value ?? ''}
          onChange={(event) => { onChange?.({ ...value, value: event.target.value }); }}
          className="!flex-row flex-wrap gap-x-4 gap-y-1 w-full"
        >
          {field?.children?.map((child) => (
            <Radio
              key={getStableKey(child, field.id)}
              className={clsx('!ml-0 whitespace-nowrap', { '!text-red-500': error })}
              label={(
                <span className={clsx({ '!text-red-500': error })}>
                  {child?.name}
                </span>
              )}
              value={child?.id ?? ''}
              size="small"
              classes={{
                root: clsx({ '!text-red-500': error }),
              }}
            />
          ))}
        </MuiRadioGroup>
      </FormControl>
    </div>
  );
}
